var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColouredCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.667 3.333c0-.368.298-.666.666-.666h9.334c.368 0 .666.298.666.666v2H2.667v-2zm12 0V8a.667.667 0 0 1-1.334 0V6.667H6.667v6.666H8a.667.667 0 0 1 0 1.334H3.333a2 2 0 0 1-2-2V3.333a2 2 0 0 1 2-2h9.334a2 2 0 0 1 2 2zm-12 3.334h2.666v6.666h-2a.667.667 0 0 1-.666-.666v-6zm9.666 2.666a.667.667 0 0 0-1.333 0V11H9.333a.667.667 0 0 0 0 1.333H11V14a.667.667 0 0 0 1.333 0v-1.667H14A.667.667 0 0 0 14 11h-1.667V9.333z",
    fill: "#500D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColouredCreate);
export default __webpack_public_path__ + "static/media/colouredCreate.503c847bf12be938caa966cb2ea56b36.svg";
export { ForwardRef as ReactComponent };